// extracted by mini-css-extract-plugin
module.exports = {"storeSection":"CreateMemorabilia_storeSection__tLDhR","autoComplete":"CreateMemorabilia_autoComplete__3Z031"};